import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Container, Paper, Typography } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { useSubscription } from '../../contexts/SubscriptionContext';

const PaymentCancelPage: React.FC = () => {
  const navigate = useNavigate();
  const { refreshSubscription } = useSubscription();

  useEffect(() => {
    // Refresh subscription status to ensure UI displays current state
    // (just in case any partial processing happened)
    const refresh = async () => {
      try {
        console.log('Payment cancel page: Refreshing subscription status');
        await refreshSubscription();
      } catch (error) {
        console.error('Error refreshing subscription on cancel page:', error);
      }
    };
    
    refresh();
    
    // Auto-redirect to home after 10 seconds
    const redirectTimer = setTimeout(() => {
      navigate('/');
    }, 10000);

    return () => clearTimeout(redirectTimer);
  }, [navigate, refreshSubscription]);

  return (
    <Container maxWidth="sm">
      <Paper
        elevation={3}
        sx={{
          p: 4,
          mt: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <CancelIcon color="error" sx={{ fontSize: 80, mb: 2 }} />
        <Typography variant="h4" component="h1" gutterBottom>
          Payment Cancelled
        </Typography>
        
        <Typography variant="body1" paragraph>
          Your payment process was cancelled. No charges have been made to your account.
        </Typography>
        
        <Typography variant="body1" paragraph>
          If you encountered any issues during checkout, please try again or contact our support team for assistance.
        </Typography>
        
        <Typography variant="body2" color="text.secondary" paragraph>
          You will be redirected to the home page automatically in a few seconds.
        </Typography>
        
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate('/')}
          sx={{ mt: 2 }}
        >
          Return to Home
        </Button>
        
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => navigate('/subscription')}
          sx={{ mt: 2 }}
        >
          Try Again
        </Button>
      </Paper>
    </Container>
  );
};

export default PaymentCancelPage; 